import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { Router } from "@angular/router";
var ActivityIntroductionComponent = (function () {
    function ActivityIntroductionComponent(apiService, router) {
        this.apiService = apiService;
        this.router = router;
        this.onApply = new EventEmitter();
    }
    ActivityIntroductionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showButton = false;
        if (this.practiceMetaId > 0) {
            this.showButton = true;
            this.choiceBtnDisable = false;
            this.choiceBtnText = "我也试试";
        }
        else {
            this.apiService.checkRegister().subscribe(function (result) {
                _this.showButton = true;
                if (result.isRegistered == true) {
                    _this.choiceBtnDisable = true;
                    _this.choiceBtnText = "已申请";
                }
                else {
                    _this.choiceBtnDisable = false;
                    _this.choiceBtnText = "申请试用";
                }
            });
        }
        this.newEdition = true;
    };
    ActivityIntroductionComponent.prototype.ngAfterViewInit = function () {
        if (!this.newEdition) {
            var html = document.documentElement;
            /*var htmlFontSize=html.clientWidth/7.5;*/
            var htmlFontSize = void 0;
            if (window.screen.width < window.screen.height) {
                htmlFontSize = window.screen.width / 7.5;
            }
            else {
                htmlFontSize = window.screen.height / 7.5;
            }
            html.style.fontSize = htmlFontSize + "px";
            html.style.backgroundColor = "#2c2c50";
            var boxHeight = document.getElementById("text_box_1").offsetHeight;
            var wrapHeight = document.documentElement.offsetHeight - 0.98 * htmlFontSize;
            $("#wrap").height(wrapHeight);
        }
        else {
            window.sessionStorage.setItem('newEdition', 'newEdition');
        }
    };
    ActivityIntroductionComponent.prototype.register = function () {
        if (!this.choiceBtnDisable) {
            var link = ['form', '3'];
            this.router.navigate(link);
            this.apiService.onApply().subscribe(function (result) {
            });
        }
        /*this.onApply.emit(true);*/
    };
    return ActivityIntroductionComponent;
}());
export { ActivityIntroductionComponent };



// WEBPACK FOOTER //
// ./src/app/activity-introduction/activity-introduction.component.ts.pre-build-optimizer.js